import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { sortObjectsByAlphabet } from "../../utils";
import * as urlService from "../../view/urlService";
import { TableContext } from "../../index";

function ChooseDeviceField({ setDeviceId, deviceId, devices = [] }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (value) => {
        setDeviceId(value);
        setConfig({ ...config, deviceId: value });

        if (Number(value) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            })
            return;
        }

        const device = devices.find(device => device.id === Number(value));

        if (device) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('device', device.hostName)
            })
        }
    }

    const devicesCopy = sortObjectsByAlphabet(devices, 'hostName');

    const options = [
        { value: -1, label: 'Choose' },
        ...devicesCopy.map(device => ({ value: device.id, label: device.hostName }))
    ];

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === Number(deviceId)) || options[0]}
            onChange={(selectedOption) => onChange(selectedOption.value)}
            options={options}
            isSearchable={true}
            placeholder="Choose"
        />
    );
}

export default ChooseDeviceField;
